import getThemeMerger from 'util/getThemeMerger'

export default getThemeMerger((currentTheme) => ({
  overrides: {
    MuiDivider: {
      root: {
        margin: `${currentTheme.spacing(2)}px 0`,
      },
    },
    MuiTypography: {
      h3: {
        /* Used in dashboard/appointment/contentBlock */
        fontSize: '2.1rem',
        fontWeight: 400,
        color: currentTheme.palette.primary.main,
      },
      h4: {
        fontSize: '1.4em',
        fontWeight: 500,
        lineHeight: 1.2,
      },
      h5: {
        lineHeight: '1.34em',
        letterSpacing: 0.2,
        color: currentTheme.palette.primary.main,
      },
      body1: {
        letterSpacing: '.03em',
      },
      body2: {
        letterSpacing: 0.25,
      },
      overline: {
        /* Used in dashboard/appointment/contentBlock */
        fontSize: '0.88rem',
        lineHeight: 1.15,
        fontWeight: 500,
        color: currentTheme.palette.tertiary.lightGrey,
      },
    },
  },
}))
